
const digest = '2fc95f0da72c77354139be5baf14247448d17a0bb279e07ae5d78f6b4a48e722';
const classes = {"wrapper":"_wrapper_gzddh_1","topCards":"_topCards_gzddh_6","title":"_title_gzddh_11"};
const css = `._wrapper_gzddh_1 {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
._wrapper_gzddh_1 ._topCards_gzddh_6 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}
._wrapper_gzddh_1 ._title_gzddh_11 {
  font-size: 18px;
  text-align: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  